import { Link, Route, Routes } from 'react-router-dom';

// Third-party packages.
import Helmet from 'react-helmet';

// Views.
import List from './List';
import Detail from './Detail';
import Breadcrumb from "../../../container/breadcrumb";
import HeaderActions from "../../../container/header_actions";
import ConditionalRender from "../../../helpers/ConditionalRender";

export default function Snapshots (props: { toggleMenu: Function, applyPeriod: Function })
{

	function refresh ()
	{
		// setLoading (true);
	}

	return (
		<div id="content">
			<Helmet>
				<title>Saved Snapshot - Settings - DBmarlin</title>
				<meta name="description" content="Manage your saved Snapshots" />
			</Helmet>

			{/* Heading */}
			<div id="top-header-wrapper" className="row row-cols-lg-3 row-cols-sm-1 row-cols-md-2">
				<Breadcrumb heading="Snapshots">
					<Link to="/admin">Settings</Link>
					<span>Snapshots</span>
				</Breadcrumb>
				<HeaderActions toggleMenu={props.toggleMenu} refresh={refresh} />
			</div>

			<div className="loader">
				<ConditionalRender if={false}>
					<div className="bar"></div>
				</ConditionalRender>
			</div>

			<div className="row row-cols-1">
				<Routes>
					<Route path="/:actionId" element={<Detail />} />
					<Route path="/:actionId/:filterId" element={<Detail />} />
					<Route path="/" element={<List />} />
				</Routes>
			</div>
		</div>
	);
}
